export default defineNuxtPlugin(async (nuxtApp) => {
  const { initialize, syncWithServer } = useAuthStore();

  // Initialize auth state on client
  await initialize();

  // Set up periodic sync with server to prevent state mismatch
  if (import.meta.client) {
    // Sync every 5 minutes
    const intervalId = setInterval(syncWithServer, 5 * 60 * 1000);

    // Sync on window focus
    const focusHandler = () => syncWithServer();
    window.addEventListener("focus", focusHandler);

    // Sync on page visibility change
    const visibilityHandler = () => {
      if (!document.hidden) {
        syncWithServer();
      }
    };
    document.addEventListener("visibilitychange", visibilityHandler);

    // Clean up on page unload
    const unloadHandler = () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", focusHandler);
      document.removeEventListener("visibilitychange", visibilityHandler);
    };
    window.addEventListener("beforeunload", unloadHandler);
  }
});
